/***
 * @file: è¡¨åç»ä»¶
 * @author: linkun.he
 * @Date: 2019-06-03 10:11:13
 */
import {
  AfterViewInit,
  Component,
  EventEmitter,
  Input,
  OnChanges,
  OnDestroy,
  OnInit,
  Output,
  SimpleChanges,
  ViewChild,
} from '@angular/core';
import { FormBuilder, FormControl, FormGroup } from '@angular/forms';
import { SettingsService } from '@ithinkdt/shared/browser';
import { cloneDeep, debounce, isEmpty, trim, values } from 'lodash';

import { getTimestamp } from '@ithinkdt/shared/utils';
// import { DtRules } from '../../utils/rules';
// import { updateRule } from '../../utils/user-rules';
import monitor from '../monitor';
function noop(file) {
  return true;
}
@Component({
  selector: 'dt-form-base',
  templateUrl: './form-base.component.html',
  styleUrls: ['./form-base.component.scss'],
})
export class FormBaseComponent implements OnChanges, OnDestroy, OnInit, AfterViewInit {
  @ViewChild('formInfo', { static: false }) formInfo: any;
  visibleFormConf;
  // å±æå±æ§
  itemWidth: number; // è¡¨åæ¯ä¸åçå®½
  // ä¸ä¼ è·¯å¾
  uploadUrl = this.settingSrv.userConfig['pages'] && this.settingSrv.userConfig['pages'].upload;
  // æä½æ¡çå±æ§
  showDialog = false;
  showModal = {};
  parentMap = {};
  confMap = {};
  errorMap = {};
  childrenKeys = [];
  //
  ist = false;
  showPropsOptions = {}; // è®¾ç½®æ¾ç¤ºéè

  // å±æå±æ§
  @Input() type = 'formSearch'; // å½åç»ä»¶çç±»å  formSearch: æç´¢ç»ä»¶ï¼ tableOpr: è¡¨æ ¼çæä½å¼¹æ¡
  @Input() validateForm: FormGroup; // ä¼ éè¿æ¥çformè¡¨å
  @Input() vertical: boolean;
  @Input() bindKey: string; // ç»å®å¤ä¸ªè¡¨åçkey

  // gutter fold showConfirmBtn lineNumber
  initalFormData = {};
  copyFormData = {};
  @Input() set formConf(configuration) {
    if (isEmpty(configuration)) {
      return;
    }
    this.createForm(configuration);
    this.visibleFormConf = configuration;
    this.packageFromData();
  }
  // å±å¼æå 
  @Input() fold = true;
  @Input() gutter = 10; // nzGutter å±æ§
  // æ¯å¦å±ç¤ºç¡®è®¤æé®ï¼æç´¢ï¼éç½®ãåæ¶ãç¡®å®ï¼
  @Input() showConfirmBtn = true;
  @Input() set formData(data: object) {
    if (!isEmpty(data)) {
      this.initalFormData = data;
      this.copyFormData = cloneDeep(data);
      this.packageFromData();
    }
  }
  @Input() lineNumber = 3; // æ¯è¡çæ°é
  @Input() labelWidth = '130'; // è¡¨ålabelçå®½åº¦
  // è¡¨åçéç½®ä¿¡æ¯
  @Input() searchByRest = true; // éç½®æ¶æ¯å¦è°ç¨æ¥è¯¢æ¥å£
  // æä½æ¡çå±æ§
  @Input() btnType = 'btn-icon'; // æé®çå±æ§ï¼ btn-icon: æé®+iconã btn: çº¯æé®ãicon: çº¯æé®ãtext: çº¯ææ¬ã text-icon: ææ¬ç±»çicon
  @Input() btnName = ''; // æé®çææ¡
  @Input() icon = ''; // æé®çiconç±»å
  @Input() dialogWidth = 980; // å¼¹æ¡çå®½åº¦
  @Input() oprType = 'add'; // add: æ°å¢ã edit: ç¼è¾ã view: æ¥ç
  @Input() onBeforeUpload: (file: any) => boolean = noop;
  @Input() downloadUrl = '';
  @Input() offsetWidth = 0; // å¨æè®¾ç½®åä¸ªæ°çå®½åº¦åæ
  @Input() isResize: boolean; // æ¯å¦å¨æ
  @Output() formSearch = new EventEmitter<any>(); // æç´¢äºä»¶
  @Output() resetFormSearch = new EventEmitter<any>(); // éç½®äºä»¶
  @Output() valueChange = new EventEmitter<any>(); // å±æ§å¼ååæ¶çäºä»¶
  @Output() valueChangeSelect = new EventEmitter<any>(); // å±æ§å¼ååæ¶çäºä»¶

  @Output() formConfirm = new EventEmitter<any>(); // å¼¹æ¡çç¡®è®¤äºä»¶
  @Output() customized = new EventEmitter<any>();
  @Output() blur = new EventEmitter<any>();
  @Output() keyup = new EventEmitter<any>();
  @Output() selectClick = new EventEmitter<any>();
  @Output() spanWidth = 8;
  formCacheData = {};

  constructor(private fb: FormBuilder, private settingSrv: SettingsService) {
    this.validateForm = this.fb.group({});
    // åå§å value æ°æ®
    monitor.on('setPropValue', ({ currentProp, targetValue, ...other }) => {
      const configuration = this.setPropValue({ currentProp, targetValue, ...other }, this.visibleFormConf);
      this.visibleFormConf = configuration;
      // this.createForm(this.visibleFormConf);
    });
    monitor.on('showModal', (modelName, state, data) => {
      this.showModal[modelName] = state;
    });
    this.resize = debounce(this.resize, 60);
  }

  ngOnInit() {
    window.addEventListener('resize', this.resize);
    monitor.on('formValueChange', debounce(this.validator, 30));
  }
  ngAfterViewInit(): void {
    this.resize();
    if (this.bindKey) {
      monitor.on('form-getValue', () => {
        return {
          bindKey: this.bindKey,
          value: this.getValue(),
        };
      });
      monitor.on('form-validate', () => {
        return {
          bindKey: this.bindKey,
          validate: this.validate(),
        };
      });
    }
  }

  validator = (prop?) => {
    if (prop && this.validateForm.controls[prop]) {
      this.validateForm.controls[prop].markAsDirty();
      this.validateForm.controls[prop].updateValueAndValidity();
      if (this.validateForm.controls[prop] && this.validateForm.controls[prop].errors) {
        const err = this.getValues(this.validateForm.controls[prop].errors);
        this.errorMap[prop] = err;
      } else if (this.errorMap[prop]) {
        this.errorMap[prop] = null;
      }
    } else if (prop) {
      this.errorMap[prop] = null;
      // this.validate();
    }

    // return !values(this.errorMap).some((i) => !!i);
  };
  // éªè¯è¡¨å
  validate() {
    if (this.validateForm && this.validateForm.controls) {
      this.errorMap = {};
      Object.keys(this.validateForm.controls).forEach((i) => {
        this.validateForm.controls[i].markAsDirty();
        this.validateForm.controls[i].updateValueAndValidity();
        if (this.validateForm.controls[i] && this.validateForm.controls[i].errors) {
          const err = this.getValues(this.validateForm.controls[i].errors);
          this.errorMap[i] = err;
        } else {
          this.errorMap[i] = null;
        }
      });
    }

    return !values(this.errorMap).some((i) => !!i);
  }

  resize = () => {
    const clientWidth = window.document.body.clientWidth - this.offsetWidth;
    if (clientWidth >= 1750) {
      this.changeSpanWidth(6);
    } else if (clientWidth >= 1350) {
      this.changeSpanWidth(8);
    } else {
      this.changeSpanWidth(12);
    }
  };

  changeSpanWidth(width) {
    if (this.itemWidth > width) {
      width = this.itemWidth;
    }
    this.spanWidth = width;
  }

  setPropValue = (opt, list) => {
    const { prop, currentProp, targetValue } = opt;
    list = list || this.visibleFormConf;
    const formData = this.validateForm.getRawValue();
    this.formCacheData = Object.assign(this.formCacheData, formData);
    this.formCacheData[currentProp] = targetValue;
    list = list.map((i) => {
      if (i.prop === prop) {
        if ((opt.showReg || opt.enbledReg) && currentProp) {
          // è§£æjs è¯­æ³
          // "data.AA === '01'"
          if (opt.showReg) {
            i.hide = new Function('data', `return !(${opt.showReg})`)(this.formCacheData);
          }
          if (opt.enbledReg) {
            i.disabled = new Function('data', `return !(${opt.enbledReg})`)(this.formCacheData);
          }
          if (i.hide) {
            if (opt.reset === false) {
              const value = this.validateForm.getRawValue();
              if (value.hasOwnProperty(i.prop)) {
                i.oldvalue = value[i.prop];
              }
            } else {
              if (monitor.events['setPropValueOf' + prop]) {
                const value = this.validateForm.getRawValue();
                const val = Array.isArray(value[prop]) ? [] : void 0;
                delete this.formCacheData[prop];
                monitor.emit('setPropValueOf' + prop, val);
              }
            }
            this.errorMap[i.prop] = null;
            setTimeout(() => {
              this.removeControl(i);
            });
          } else {
            this.analysisConf(i);
            if (opt.hasOwnProperty('value') && this.validateForm.controls[i.prop]) {
              if (opt.reset === false && i.hasOwnProperty('oldvalue')) {
                this.validateForm.controls[i.prop].setValue(i.oldvalue);
              } else {
                this.validateForm.controls[i.prop].setValue(prop.value);
              }
            }
          }
        }
      }
      if (Array.isArray(i.confList)) {
        this.setPropValue(opt, i.confList);
      }
      return i;
    });
    return list;
  };

  ngOnDestroy(): void {
    monitor.off('showModal');
    monitor.off('setPropValue');
    monitor.off('form-getValue');
    monitor.off('form-validate');
    window.removeEventListener('resize', this.resize);
  }

  ngOnChanges(sc: SimpleChanges) {
    if (sc['formData'] && sc['formData'].currentValue) {
      this.initFormData();
      this.ist = false;
    }
    this.initCuolmnWidth();
  }

  // æå»ºform
  createForm(configuration = [], isInline?) {
    configuration.forEach((item) => {
      const { confList } = item;
      item.level = 1;
      if (!isEmpty(confList)) {
        confList.forEach((confItem) => {
          confItem.level = 2;
          confItem.parentConfProp = [item.prop];
          if (!isEmpty(confItem.confList)) {
            confItem.confList.forEach((i) => {
              i.level = 3;
              i.parentConfProp = [item.prop, confItem.prop];
              this.analysisConf(i, isInline);
            });
          } else {
            this.analysisConf(confItem, isInline);
          }
        });
        return;
      }
      this.analysisConf(item, isInline);
    });
    this.setParentControl();
  }

  // isInline åé¨æä½ æ°å¢ & å é¤
  analysisConf(conf, isInline?) {
    const { prop, value, validators, disabled, parentKey, hide, type } = conf;
    if (hide === true && type !== 'hide') {
      return;
    }
    if (prop) {
      this.setParentMap(conf);
      this.registerFormControl(prop, value, disabled, validators, isInline);
    }
  }

  setParentControl() {
    const keys = Object.keys(this.parentMap);
    keys.forEach((key) => {
      if (this.parentMap[key] && !this.validateForm.controls[key]) {
        this.validateForm.registerControl(key, new FormControl({ value: values(this.parentMap[key]) }));
      }
    });
  }

  setParentMap(conf) {
    const { prop, parentKey } = conf;
    const value = this.validateForm.value[prop] || conf.value;
    if (parentKey) {
      this.confMap[parentKey] = conf.parentConfProp;
      if (!this.childrenKeys.includes(prop)) {
        this.childrenKeys.push(prop);
      }
      if (!this.parentMap[parentKey]) {
        this.parentMap[parentKey] = {};
      }
      if (conf.repeatIndex === undefined) {
        if (!this.parentMap[parentKey][0]) {
          this.parentMap[parentKey][0] = {};
        }
        // this.parentMap[parentKey][0][prop.replace(/&[\d]+$/, '')] = value;
      } else {
        // if (!this.parentMap[parentKey][conf.repeatIndex]) {
        //   this.parentMap[parentKey][conf.repeatIndex] = {};
        // }
        // this.parentMap[parentKey][conf.repeatIndex][prop.replace(/&[\d]+$/, '')] = value;
      }
    }
  }

  onEmitModal(data) {
    this.customized.emit(data);
  }

  // åå§åè¡¨åæ°æ®
  initFormData() {
    if (this.initalFormData) {
      this.validateForm.patchValue(this.initalFormData);
      this.formCacheData = this.initalFormData;
    }
  }

  // åå§åæ¯ä¸ªæ§ä»¶çå®½åº¦
  initCuolmnWidth() {
    this.itemWidth = 24 / this.lineNumber;
  }

  // æ°å¢è¡¨åæ§ä»¶
  registerFormControl(prop, value = null, disabled = false, validators = [], isInline?) {
    if (isInline) {
      const data = this.validateForm.getRawValue();
      const key = prop.replace(/&0$/, '');
      if (data.hasOwnProperty(key)) {
        value = [prop];
      }
    }
    this.validateForm.registerControl(prop, new FormControl({ value, disabled }, validators));
  }

  // å¼¹æ¡çæäº¤ï¼ç¡®å®ï¼äºä»¶
  submit() {
    this.check();
    if (this.validateForm.valid) {
      const form = this.validateForm.getRawValue();
      this.formConfirm.emit(form);
    }
  }

  // æç´¢äºä»¶
  search() {
    this.check();
    if (this.validateForm.valid) {
      const form = this.handleFormData(this.validateForm.getRawValue());
      this.formSearch.emit(form);
    }
  }

  // å¤çä¸ä¼ çæ°æ®ï¼å¼ä¼ éid
  handleFormData(form) {
    this.visibleFormConf.forEach((item) => {
      switch (item.type) {
        case 'upload':
          form[item.prop] = form[item.prop]
            ? form[item.prop].map((t) => {
                return t.fileId;
              })
            : [];
          break;
        case 'linkageSelect':
          this.ergodicProperties(item, form);
          break;
        case 'datePickerRange':
          this.transformationDateType(item, form);
          this.ergodicProperties(item, form);
          break;
        case 'datePicker':
        case 'datePickerYear':
        case 'datePickerMonth':
        case 'datePickerWeek':
        case 'datePickerTime':
          this.transformationDateType(item, form);
          break;
        default:
      }
    });
    return form;
  }

  // å¤çèå´æ§çæ å½¢
  ergodicProperties(item, form) {
    if (!item.keys) {
      return;
    }
    item.keys.forEach((t, i) => {
      form[t] = form[item.prop] && form[item.prop][i] ? form[item.prop][i] : '';
    });
  }

  // å°æ¥ææ ¼å¼è½¬æ¢ææ¶é´æ³ï¼ä¸å¨æ¶é´æ§ä»¶é ç´æ¥è½¬æ¢ï¼æä½æ§ä»¶æ¶éè¦éæ°èµå¼å¶ä»æ§ä»¶ï¼
  transformationDateType(item, form) {
    // æ¥æèå´
    if (Object.prototype.toString.call(form[item.prop]) === '[object Array]') {
      if (form[item.prop].length) {
        form[item.prop] = form[item.prop].map((t) => {
          return getTimestamp(new Date(t));
        });
      }
      return;
    }
    // å¶ä»æ¥ææ ¼å¼
    if (form[item.prop]) {
      form[item.prop] = getTimestamp(new Date(form[item.prop]));
    }
  }

  // æç´¢ãæäº¤ççæ£æµäºä»¶
  check() {
    return this.validate();
    // for (const i in this.validateForm.controls) {
    //   // let val = this.validateForm.controls[i].value;
    //   // if (typeof val === 'string') {
    //   //   val = trim(val);
    //   //   this.validateForm.controls[i].setValue(val);
    //   // }
    //   this.validateForm.controls[i].markAsDirty();
    //   this.validateForm.controls[i].updateValueAndValidity();
    // }
  }

  // éç½®äºä»¶
  reset() {
    this.validateForm.reset();
    this.resetFormSearch.emit();
    if (this.searchByRest) {
      this.search();
    }
  }

  // æ¶èµ·ãå±å¼äºä»¶
  toggleCollapse() {
    this.fold = !this.fold;
  }

  // å¼¹æ¡çæå¼äºä»¶
  openDialog() {
    this.showDialog = true;
  }

  // å¼¹æ¡çåæ¶äºä»¶
  close() {
    this.showDialog = false;
  }

  calcError(conf) {
    if (
      this.validateForm.controls &&
      this.validateForm.controls[conf.prop] &&
      this.validateForm.controls[conf.prop].errors &&
      this.validateForm.controls[conf.prop].dirty &&
      this.getValues(this.validateForm.controls[conf.prop].errors)
    ) {
      return true;
    }
    return false;
  }

  // è·åæ¥éä¿¡æ¯
  getValues(rules: any): any {
    const arr = [];
    Object.keys(rules).map((item) => {
      arr.push(rules[item]);
    });
    return arr[0];
  }

  // æ§ä»¶åæ´æ¶çäºä»¶è§¦å
  onValueChange(prop, value, type?) {
    const change = {
      prop,
      value,
    };
    if (this.validateForm.controls[prop] && !type) {
      this.validateForm.controls[prop].setValue(value);
    }
    this.valueChange.emit(change);
  }

  onSelectValueChange(prop, value) {
    const change = {
      prop,
      value,
    };
    this.valueChangeSelect.emit(change);
  }

  onBlur(prop, evt) {
    this.blur.emit({
      value: evt,
      prop,
    });
  }

  onKeyup(prop, evt) {
    this.keyup.emit({
      value: evt,
      prop,
    });
  }
  onSelectClick(prop, evt) {
    this.selectClick.emit({
      value: evt,
      prop,
    });
  }

  // å¤ä¸ªå¤å¶çæåµ
  repeatAll(prop, visibleFormConf: any[]) {
    if (Array.isArray(prop) && prop.length) {
      prop.forEach((key) => this.repeat(key, visibleFormConf, prop.length));
    } else {
      this.repeat(prop, visibleFormConf);
    }
  }

  // å¤å¶æ°æ®
  repeat(prop, visibleFormConf: any[], length = 1, isRemove?) {
    if (prop) {
      let repeatData: any = null;
      let currnetIndex = 0;

      visibleFormConf.forEach((i, index) => {
        if (i.prop && i.prop.replace(/&[\d]+$/, '') === prop) {
          i.delete = true;
          // ç¬¬ä¸æ¬¡å¤å¶æ¶
          if (i.repeatIndex === undefined) {
            i.repeatIndex = 0;
            const copyData = cloneDeep(i);
            const data = this.copy(i, 0);
            this.createForm([data], true);
            // // å¼æ­¥å é¤
            if (!isRemove) {
              setTimeout(() => {
                this.removeControl(copyData);
              }, 30);
            }
          }
          repeatData = cloneDeep(i);
          currnetIndex = index;
        }
      });
      if (repeatData) {
        const copyData = this.copy(repeatData, repeatData.repeatIndex + length, true);
        visibleFormConf.splice(currnetIndex + length, 0, copyData);
        this.createForm([copyData], true);
      }
    }
  }

  /**
   * å¤å¶æ°æ®
   * @param repeatData å¤å¶çæ°æ®
   * @param index ç´¢å¼
   */
  copy(repeatData, index, isCreate?) {
    // æ¨¡åçæåµ
    if (repeatData) {
      // å±æ§å ä¸ç´¢å¼å¼åºå
      if (repeatData.prop) {
        repeatData.prop = repeatData.prop.replace(/&[\d]+$/, '') + '&' + index;
      }
      repeatData.repeatIndex = index;
      // å¼æ¸ç©º
      if (isCreate) {
        repeatData.value = Array.isArray(repeatData.value) ? [] : undefined;
      }
      repeatData.delete = true;
      if (Array.isArray(repeatData.confList)) {
        repeatData.confList.forEach((conf) => {
          this.copy(conf, index, isCreate);
        });
      }
    }
    return repeatData;
  }

  deepRemove(conf, repeatIndex) {
    const _key = conf.prop && conf.prop.replace(/&[\d]+$/, '');
    if (this.parentMap[_key]) {
      delete this.parentMap[_key][repeatIndex];
      this.validateForm.controls[_key].setValue(values(this.parentMap[_key]));
    }
    if (Array.isArray(conf.confList)) {
      conf.confList.forEach((item) => this.deepRemove(item, repeatIndex));
    }
  }

  deleteForm(conf, visibleFormConf: any[]) {
    if (Array.isArray(visibleFormConf)) {
      let currentIndex = -1;
      visibleFormConf.forEach((i, index) => {
        if (i.prop === conf.prop) {
          currentIndex = index;
        }
        if (Array.isArray(i.confList)) {
          i.confList.forEach((_conf) => {
            this.deleteForm(conf, _conf);
          });
        }
      });
      if (currentIndex > -1) {
        this.removeControl(conf);
        visibleFormConf.splice(currentIndex, 1);
        this.deepRemove(conf, conf.repeatIndex);
        const key = conf.prop.replace(/&[\d]+$/, '');
        let count = 0;
        let _index = -1;
        visibleFormConf.forEach((c, _i) => {
          if (c.prop && c.prop.replace(/&[\d]+$/, '') === key) {
            count++;
            _index = _i;
          }
        });
        if (count === 1) {
          visibleFormConf[_index].delete = null;
          delete visibleFormConf[_index].delete;
        }
      }
    }
  }

  removeControl(conf) {
    if (conf && conf.prop) {
      if (!this.parentMap[conf.prop]) {
        this.errorMap[conf.prop] = null;
        this.validateForm.removeControl(conf.prop);
      }
      if (Array.isArray(conf.confList)) {
        conf.confList.forEach((i) => this.removeControl(i));
      }
    }
  }

  // åè£¹æ°æ®åå§åå¤ç
  packageFromData() {
    // è®¾ç½®è¢«åè£¹æ°æ®
    if (!isEmpty(this.visibleFormConf) && !isEmpty(this.initalFormData) && !this.ist) {
      this.ist = true;
      const keys = Object.keys(this.parentMap);
      // this.initFormData();
      // åå§åä¼ å¥è¡¨åæ°æ®å¤ç
      if (keys.length) {
        Object.keys(this.initalFormData).forEach((k) => {
          if (keys.includes(k)) {
            if (Array.isArray(this.initalFormData[k]) && this.initalFormData[k].length) {
              const o = {};
              Object.keys(this.initalFormData[k]).forEach((item) => {
                this.parentMap[k][item] = cloneDeep(this.initalFormData[k][item]);
                this.parentMap[k] = cloneDeep(this.parentMap[k]);
              });

              this.validateForm.patchValue({
                [k]: values(this.parentMap[k]),
              });
              // this.initalFormData
            }
          }
        });

        // parentMap å¤ç,å¡åé¨å¼
        const repeatParentMap = {};
        keys.forEach((key) => {
          const parentMapData = cloneDeep(values(this.parentMap[key]));
          if (Array.isArray(parentMapData) && parentMapData.length) {
            let cacheKey = key;
            if (this.confMap[key]) {
              cacheKey = this.confMap[key][0].replace(/&[\d]+$/, '');
              if (!repeatParentMap[cacheKey]) {
                parentMapData.slice(1).forEach((map, index) => {
                  this.repeat(cacheKey.replace(/&[\d]+$/, ''), this.visibleFormConf, 1, true);
                });
              }
              repeatParentMap[cacheKey] = true;
            } else {
              this.repeat(key.replace(/&[\d]+$/, ''), this.visibleFormConf, 1, true);
            }

            setTimeout(() => {
              parentMapData.slice(1).forEach((map, index) => {
                Object.keys(map).forEach((i) => {
                  this.childrenKeys.forEach((r) => {
                    if (new RegExp(i + `@\\d+`).test(r)) {
                      i = r;
                    }
                  });
                  const formKey = i + '&' + (index + 1);
                  if (this.validateForm.controls[formKey]) {
                    this.validateForm.controls[formKey].setValue(map[i]);
                  }
                });
              });
              parentMapData.slice(0, 1).forEach((item) => {
                const _keys = Object.keys(item).reverse();
                _keys.forEach((_key) => {
                  this.childrenKeys.forEach((r) => {
                    if (new RegExp(_key + `@\\d+`).test(r)) {
                      _key = r;
                    }
                  });
                  let da = _key;
                  if (parentMapData.length > 1) {
                    da = _key + '&' + 0;
                  }
                  if (this.validateForm.controls[da]) {
                    this.validateForm.controls[da].setValue(item[_key]);
                    // é²æ­¢ç»ä»¶æ²¡ææ´æ°
                    if (this.validateForm.controls[_key] && da !== _key) {
                      this.validateForm.controls[_key].setValue(item[_key]);
                      setTimeout(() => {
                        this.validateForm.removeControl(_key);
                      }, 30);
                    }
                  }
                });
              });
            }, 30);
          }
        });
      }
    }
  }

  setParentValue = (conf, value) => {
    if (conf.parentKey) {
      if (!this.childrenKeys.includes(conf.prop)) {
        this.childrenKeys.push(conf.prop);
      }
      if (!this.parentMap[conf.parentKey]) {
        this.parentMap[conf.parentKey] = {};
      }
      if (conf.repeatIndex === undefined) {
        this.parentMap[conf.parentKey]['0'][conf.prop] = value;
      } else {
        if (!this.parentMap[conf.parentKey][conf.repeatIndex]) {
          this.parentMap[conf.parentKey][conf.repeatIndex] = {};
        }
        this.parentMap[conf.parentKey][conf.repeatIndex][conf.prop.replace(/&[\d]+$/, '')] = value;
      }
      // if (this.validateForm.controls[conf.prop]) {
      //   this.validateForm.controls[conf.prop].setValue(value);
      // }

      if (!this.validateForm.controls[conf.parentKey]) {
        this.validateForm.registerControl(conf.parentKey, new FormControl(this.parentMap[conf.parentKey]));
      } else {
        this.validateForm.controls[conf.parentKey].setValue(values(this.parentMap[conf.parentKey]));
      }
    }
  };

  // è·åè¡¨åçæææ°æ®
  getValue() {
    const value = this.validateForm.getRawValue();
    const o = {};
    Object.keys(value).forEach((i) => {
      if (!(/&[\d]+$/.test(i) || /@[\d]+$/.test(i.replace(/&[\d]+$/, '')))) {
        // å é¤key æ @[\d]+ ç
        if (this.parentMap[i] && Array.isArray(value[i])) {
          value[i] = value[i].map((item) => {
            const no = {};
            Object.keys(item).forEach((k) => {
              const _k = this.replaceSuffix(k);
              no[_k] = item[k];
            });
            return no;
          });
        }
        o[i] = value[i];
      }
    });
    return Object.assign(this.copyFormData, o);
  }

  // åæ¶æ¾éå¤çkey ä¿è¯è¾åºä¸è´
  replaceSuffix(str) {
    if (str) {
      return str.replace(/&[\d]+$/, '').replace(/@[\d]+$/, '');
    }
    return str;
  }
}
